import Links from '@/shared/constants/navegacao';
import Loading from '@/shared/components/Carregando';
import { getFolhaEstagiarioMesAtualPorToken } from '../../../attendance-sheet.service';
import { toast } from 'react-toastify';
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

export default function EstagiarioFolhaAtualPage() {
  const navigate = useNavigate();
  const startedRef = useRef(false);

  useEffect(() => {
    if (startedRef.current) return;
    startedRef.current = true;

    void getFolhaEstagiarioMesAtualPorToken()
      .then(({ id }) => {
        if (id) {
          navigate(`${Links.Folha_Frequencia_Editar}/${id}`, { replace: true });
          return;
        }
        toast.warn('Não há folha de frequência para o mês atual.');
        navigate(Links.Estagiario_Minhas_Folhas, { replace: true });
      })
      .catch(() => {
        toast.error('Não foi possível localizar a folha do mês atual.');
        navigate(Links.Estagiario_Minhas_Folhas, { replace: true });
      });
  }, [navigate]);

  return <Loading />;
}
